var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 2,
    viewBox: "0 0 14 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.976218 1.62043H13.0303C13.3747 1.62043 13.6663 1.32559 13.6663 0.97722C13.6663 0.628853 13.3747 0.333984 13.0303 0.333984H0.976218C0.624631 0.333984 0.333008 0.628853 0.333008 0.97722C0.333008 1.32559 0.624631 1.62043 0.976218 1.62043Z",
    fill: "#A3A09A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.a03dc912df7a1188576011d733c5b23c.svg";
export { ForwardRef as ReactComponent };